import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../core/services/api.service';
import { ProjectPhotoAnnotationModel } from '../models/projectphoto.model';

@Injectable({
  providedIn: 'root'
})
export class BlockScheduleFileService {
  constructor(private apiService: ApiService) {}

  getFileAnnotation(fileId: number): Observable<ProjectPhotoAnnotationModel> {
    return this.apiService.get(`BlockScheduleFile/GetFileAnnotation/${fileId}`);
  }

  updateFileAnnotation(fileId: number, annotationXfdf: string | null): Observable<any> {
    return this.apiService.put(`BlockScheduleFile/UpdateFileAnnotation/${fileId}`, { annotationXfdf });
  }

  downloadFile(fileId: number, optimized: boolean): Observable<Blob> {
    return this.apiService.getBlob(`BlockScheduleFile/DownloadFile/${fileId}?optimized=${optimized}`);
  }
}
